import { DivergingBarMiniChart } from "./svgPrimitives";

interface WinsLossesPoint {
  trade_date: string;
  wins: number;
  losses: number;
}

interface WinsLossesChartProps {
  points: ReadonlyArray<WinsLossesPoint>;
  fill?: boolean;
}

export function WinsLossesChart({ points, fill }: WinsLossesChartProps) {
  return (
    <DivergingBarMiniChart
      wins={points.map((p) => p.wins)}
      losses={points.map((p) => p.losses)}
      labels={points.map((p) => p.trade_date)}
      testId="wins-losses-chart"
      fill={fill}
    />
  );
}
